import React, { useRef } from 'react'
import styled from 'styled-components';
import HeadingContainer from '@components/HeadingContainer';
import EducationCard from './components/EducationCard';
import { EducationList } from './components/List';

function Education({ sectionRefs }) {

  const scrollRef = useRef(null);

  return (
    <Container
      ref={(el) => {
      sectionRefs.current = { ...sectionRefs.current, Education: el };
      scrollRef.current = el;
    }}
    >
      <HeadingContainer writeups={'Education'}/>
      <EducationContainer>
        {EducationList.map((edu, idx) => (
          <CardContainer key={idx}>
            <EducationCard
              college={edu.college}
              mode={edu.mode}
              timeline={edu.timeline}
              gpa={edu.gpa}
            />
          </CardContainer>
        ))}
      </EducationContainer>
    </Container>
  )
}

export default Education;

const Container = styled.section`
  width: 100%;
`;

const EducationContainer = styled.div`
  padding: 5vw;
  width: 90%;
  display: grid;
  /* gap: 2vw; */
`;

const CardContainer = styled.div``;
